export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7247.de72f043.jpg";